import { apiRequest } from '@services/apiClient';
import startPointsEndpoints from '@services/startPoints/startPointsEndpoints';

// Creates a new start point in CMS.
export function createStartPointRequest(payload) {
  return apiRequest(startPointsEndpoints.base, {
    method: 'POST',
    body: payload
  });
}

// Updates an existing start point by id.
export function updateStartPointRequest(id, payload) {
  return apiRequest(startPointsEndpoints.byId(id), {
    method: 'PUT',
    body: payload
  });
}

// Deletes one start point by id.
export function deleteStartPointRequest(id) {
  return apiRequest(startPointsEndpoints.byId(id), {
    method: 'DELETE'
  });
}

// Upsert helper: updates when id exists, falls back to create on 404.
export async function saveStartPointRequest(payload) {
  const pointId = payload?.id;
  if (!pointId) return createStartPointRequest(payload);
  try {
    return await updateStartPointRequest(pointId, payload);
  } catch (error) {
    if (Number(error?.status) === 404) {
      return createStartPointRequest(payload);
    }
    throw error;
  }
}

function normalizeStartPointsFromBody(body) {
  // Supports multiple backend response shapes for list/read endpoints.
  const source = Array.isArray(body?.startPoints)
    ? body.startPoints
    : Array.isArray(body?.items)
      ? body.items
      : Array.isArray(body)
        ? body
        : body?.startPoint && typeof body.startPoint === 'object'
          ? [body.startPoint]
          : [];
  return source.map((item) => ({ ...item, isPersisted: true }));
}

export async function listStartPointsByTourRequest(tourId) {
  const encodedId = encodeURIComponent(tourId || '');
  // Tries known list endpoint variants used across environments.
  const candidates = [
    `${startPointsEndpoints.base}?tourId=${encodedId}`,
    `${startPointsEndpoints.base}/tour/${encodedId}`
  ];

  let lastError = null;
  for (const path of candidates) {
    try {
      const response = await apiRequest(path);
      return normalizeStartPointsFromBody(response?.body);
    } catch (error) {
      if (Number(error?.status) === 404) {
        lastError = error;
        continue;
      }
      throw error;
    }
  }
  if (lastError) return [];
  return [];
}
